import { CreateMarketCategoryDto, MarketCategoryDto } from '@careapp-group/ng-sdk-v2-new';
import { BaseFilterType, CaEntityActionsFactory } from '../entity-state/entity-actions-factory';

class MarketManagementCategoryActions extends CaEntityActionsFactory<
  MarketCategoryDto,
  CreateMarketCategoryDto,
  unknown,
  BaseFilterType
> {
  constructor() {
    super(`MarketManagementCategories`);
  }
}

export const MarketManagementCategories = new MarketManagementCategoryActions();
